export default __webpack_public_path__ + "static/media/2_0066.05716f15.webp";